/// <amd-module name="Artifacts/Cargo/redux/Actions" />
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {
  IDefaultActionPayload,
  IDeleteActionPayload,
  IListActionPayload,
  IPromoteActionPayload,
  IRestoreActionPayload,
  IUpstreamOverrideActionPayload,
} from "Artifacts/Root/Protocols/types/ICommandActionPayloads";
import { trackActionWithCount } from "Artifacts/Root/redux/Actions";
import { IFeed, IPackageVersionIdentity } from "Artifacts/Root/types";
import { ActionsUnion, createAction, trackedAction } from "redux/Utils/ActionHelper";

export const enum CargoActionTypes {
  Promote = "Artifacts/Cargo/Promote",
  Download = "Artifacts/Cargo/Download",
  PermanentDelete = "Artifacts/Cargo/PermanentDelete",
  Restore = "Artifacts/Cargo/Restore",
  YankOrUnyank = "Artifacts/Cargo/YankOrUnyank",
  SoftDelete = "Artifacts/Cargo/SoftDelete",
  SetUpstreamOverride = "Artifacts/Cargo/SetUpstreamOverride",
}

export const CargoActions = {
  promote: (
    feed: IFeed,
    versions: IPackageVersionIdentity[],
    viewId: string,
    onSuccessCallback: () => void,
  ) =>
    trackActionWithCount(
      createAction<CargoActionTypes, IPromoteActionPayload>(CargoActionTypes.Promote, {
        feed,
        versions,
        viewId,
        onSuccessCallback,
      }),
      versions.length,
    ),
  download: (feed: IFeed, versions: IPackageVersionIdentity[]) =>
    trackActionWithCount(
      createAction<CargoActionTypes, IDefaultActionPayload>(CargoActionTypes.Download, {
        feed,
        versions,
      }),
      versions.length,
    ),
  permanentDelete: (
    feed: IFeed,
    versions: IPackageVersionIdentity[],
    onSuccessCallback: () => void,
  ) =>
    trackActionWithCount(
      createAction<CargoActionTypes, IDeleteActionPayload>(CargoActionTypes.PermanentDelete, {
        feed,
        versions,
        onSuccessCallback,
      }),
      versions.length,
    ),
  restore: (feed: IFeed, versions: IPackageVersionIdentity[], onSuccessCallback: () => void) =>
    trackActionWithCount(
      createAction<CargoActionTypes, IRestoreActionPayload>(CargoActionTypes.Restore, {
        feed,
        versions,
        onSuccessCallback,
      }),
      versions.length,
    ),
  changeListStatus: (
    feed: IFeed,
    versions: IPackageVersionIdentity[],
    isListed: boolean,
    onSuccessCallback: () => void,
  ) =>
    trackActionWithCount(
      createAction<CargoActionTypes, IListActionPayload>(CargoActionTypes.YankOrUnyank, {
        feed,
        versions,
        isListed,
        onSuccessCallback,
      }),
      versions.length,
    ),
  softDelete: (feed: IFeed, versions: IPackageVersionIdentity[], onSuccessCallback: () => void) =>
    trackActionWithCount(
      createAction<CargoActionTypes, IDeleteActionPayload>(CargoActionTypes.SoftDelete, {
        feed,
        versions,
        onSuccessCallback,
      }),
      versions.length,
    ),
  setUpstreamOverride: (
    feed: IFeed,
    packageName: string,
    allowExternalVersions: boolean,
    onSuccessCallback: () => void,
  ) =>
    trackedAction(
      createAction<CargoActionTypes, IUpstreamOverrideActionPayload>(
        CargoActionTypes.SetUpstreamOverride,
        { feed, packageName, allowExternalVersions, onSuccessCallback },
      ),
    ),
};

export type CargoActionsUnion = ActionsUnion<typeof CargoActions>;
